export default function LangToggle({ lang, setLang }) {
  return (
    <button
      onClick={() => setLang(lang === "es" ? "pt" : "es")}
      className="px-2 py-1 rounded-full text-xs font-bold bg-white/20 hover:bg-white/30 transition-colors"
      data-testid="lang-toggle"
    >
      {lang === "es" ? "PT" : "ES"}
    </button>
  );
}
